<template>
  <section>
    <div class="grid grid-cols-12 mt-8">
      <div class="col-span-6 lg:col-span-6 xxl:col-span-6">
        <h2 class="intro-y text-lg font-medium mr-auto mt-2 mb-2">
          Biblioteca ({{ filteredLibraries.length  }})
        </h2>
      </div>
      <div class="col-span-6 lg:col-span-6 xxl:col-span-6">
        <div class="col-span-6">
          <input type="text" class="input w-full border mt-2 flex-1"
            placeholder="Buscar por nombre..." v-model="filter.slug">
        </div>
      </div>

      <div class="col-span-12 lg:col-span-12 xxl:col-span-12 mb-4">
        <p class="w-full">Filtrar por cualquiera de las siguientes categorias:</p>
        <div class="intro-y mt-2 flex flex-wrap">
            <button class="button border-theme-5 border flex mr-1 mb-2"
              :class="{'bg-theme-1 text-white': filter.category == null}"
              @click="setCategory(null)">
              <app-icon name="layers" classname="w-4 h-4 mr-2 mt-1" />
              Todas las categorias
            </button>
            <button class="button border-theme-5 border flex mr-1 mb-2"
              :class="{'bg-theme-1 text-white': categoryMenu.name == filter.category}"
              @click="setCategory(categoryMenu.name)"
              v-for="categoryMenu in filteredCategories" :key="`category-${categoryMenu.name}`">
              <app-icon :name="categoryMenu.icon ? categoryMenu.icon : 'file'" classname="w-4 h-4 mr-2 mt-1" />
              {{categoryMenu.name}}
            </button>
        </div>
      </div>

      <div class="col-span-12 lg:col-span-12 xxl:col-span-12 mb-4">
        <p class="w-full">Filtrar por cualquiera de los siguientes equipos:</p>
        <div class="intro-y mt-2 flex flex-wrap">
            <button class="button border-theme-5 border flex mr-1 mb-2"
              :class="{ 'bg-theme-1 text-white': filter.team == null }"
              @click="setTeam(null)">
              <app-icon name="layers" classname="w-4 h-4 mr-2 mt-1" />
              Todos los equipos
            </button>
            <button class="button border-theme-5 border flex mr-1 mb-2"
              :class="{ 'bg-theme-1 text-white': teamMenu.id == filter.team }"
              @click="setTeam(teamMenu.id)"
              v-for="teamMenu in teams" :key="`team-${teamMenu.name}`">
              {{ teamMenu.name }}
            </button>
        </div>
      </div>
    </div>

    <div v-if="loading">
      <div class="grid grid-cols-12">
        <div class="intro-y col-span-12 sm:col-span-12 md:col-span-4 xxl:col-span-4 mr-2 mb-2"
          v-for="library in filteredLibraries"
          :key="`library-${library.slug}`">
          <a target="_blank" :href="library.url">
            <div class="box h-full zoom-in">
              <div class="rounded-md px-5 py-4 mb-2">
                <div class="flex items-center">
                    <div class="font-medium text-lg">{{ library.name }}</div>
                    <div class="text-xs bg-gray-600 px-1 rounded-md text-white ml-auto">{{ library.category }}</div>
                </div>
                <div class="mt-3 mb-2">
                  {{ library.description }}
                </div>
                <div class="text-theme-1 hidden text-right font-bold" v-if="library.url">
                  Da clic para abrir
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>

    <app-loading v-else />

  </section>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import Icon from '@/components/admin/partials/Icon'
  import Loading from '@/components/admin/partials/LoadingWhite'

  export default {
    name: 'AdminListLibrary',
    data () {
      return {
        loading: false,
        boxedit: false,
        library_current: {},
        categories: [],
        filter: {
          slug: null,
          category: null,
          team: null,
        }
      }
    },
    async beforeMount () {
      try {
        await this.getList('account')
        const { categories } = await this.getList('library')
        this.categories = categories

        this.loading = true
      } catch (error) {}
    },
    methods: {
      setCategory(name) {
        this.filter.category = name
      },
      setTeam(id) {
        this.filter.team = id
      },
      ...mapActions([
        'getList',
        'getAll'
      ])
    },
    computed: {
      ...mapGetters({
        libraries: 'getLibraries',
        accounts: 'getAccounts',
        user: 'getUser',
        teams: 'getTeams'
      }),
      filteredLibraries() {
        let items = this.libraries.filter(library => {
          let category = this.filter.category ? library.category == this.filter.category : true;
          let team = this.filter.team ? library.team_createdby_id == this.filter.team : true;
          let slug = this.filter.slug ? library.name.toLowerCase().includes(this.filter.slug.toLowerCase()) : true;

          return category && team && slug;
        })

        return items
      },
      filteredCategories() {
        return this.categories.filter(category =>
          (category.name !== "Anuncios")
        )
      }
    },
    components: {
      appIcon: Icon,
      appLoading: Loading,
    },
  }
</script>



// WEBPACK FOOTER //
// LibraryTeam.vue?14311887